import { routes } from '@sunucupark/shared/lite';
import type { WebClient } from './client';
import { contractSchema } from '@/shared/contracts';

/**
 * The inbox's id, as this mailbox names it. Some servers always use the same
 * number, but the id belongs to the server, so it is read from the folder list
 * and remembered for the session — never written into the client as a constant.
 */
let cached: Promise<string> | null = null;

export function inboxFolderIdOf(client: WebClient): Promise<string> {
  cached ??= load(client).catch((error: unknown) => {
    cached = null;
    throw error;
  });
  return cached;
}

async function load(client: WebClient): Promise<string> {
  const answer = await client.api.request({
    path: routes.mail.folders,
    schema: contractSchema((contracts) => contracts.FolderListResponseSchema),
  });
  const inbox = answer.folders.find((folder) => folder.systemKind === 'inbox');
  if (!inbox) throw new Error('The mailbox has no inbox folder');
  return inbox.id;
}

/** Forgets the cached id; used when the session ends. */
export function forgetInboxFolderId(): void {
  cached = null;
}
